import { Capabilities, Capability } from 'src/types/capabilities';
import { useMeContext } from './use-context';

export const useCapabilities = (): Capabilities => useMeContext().capabilities;

export const useCrudCapabilities = (entity: Capability) => {
  const capabilities = useCapabilities();

  // use the finest available granularity
  const check = (action: string) =>
    `${entity}.${action}` in capabilities
      ? capabilities[`${entity}.${action}` as Capability]
      : capabilities[entity];

  return {
    create: check('create'),
    update: check('update'),
    delete: check('delete')
  };
};
